import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioEpicrisisService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getInformacionAfiliado (obj: EpicrisisEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'epicrisis/afiliado',
        [
          obj.codigo,
          {
            'historia' : obj.uncoHistoria,
            'formato_impreso' : obj.formatoImpreso
          }
        ]
      );
      return response;
    } catch (e) {
      console.error('ServicioEpicrisisService.getInformacionAfiliado()', e);
    }
  }

  async getCuerpoEpicrisis(obj: EpicrisisEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'epicrisis/informacion',
        [
          obj.codigo,
          {
            'historia' : obj.uncoHistoria,
            'imprime_servicios' : obj.imprimeServicios
          }
        ]
      );
      return response;
    } catch(e) {
      console.error('ServicioEpicrisisService.getCuerpoEpicrisis()', e);
    }
  }

}

export interface EpicrisisEntity {
  codigo ?: string;
  uncoHistoria ?: number;
  uncoSede ?: number;
  uncoLogin ?: number;
  formatoImpreso ?: boolean;
  imprimeServicios ?: boolean;
  imprimeCausalAccidente ?: boolean;
}

export interface EpicrisisInformacionAfiliado{
  uncoEntidad: number;
  uncoProfesional: number;
  fechaAtencion: number;
  afiliado: string;
  cama: string;
  celular: string;
  direccion: string;
  documento: string;
  edad: string;
  entidadEmpresarial: string;
  empresa: string;
  especialidad: string;
  estrato: string;
  firmaDigital: string;
  historiaClinica: string;
  identificacion: string;
  identificacionProfesional: string;
  fechaNacimiento: string;
  lineaProducto: string;
  paciente: string;
  profesionalSalud: string;
  puntoAtencion: string;
  registroMedico: string;
  sede: string;
  sexo: string;
  telefono: string;
  tipoAfiliado: string;
  tipoAtencion: string;
}

export interface EpicrisisCuerpo {
  unco: number;
  uncoProfesional: number;
  fechaIngreso: number;
  fechaEgreso: number;
  causaSalida: string;
  especialidadMedico: string;
  firmaDigital: string;
  observaciones: string;
  puntoAtencionEntrada: string;
  puntoAtencionSalida: string;
  profesionalEpicrisis: string;
  registroMedico: string;
  textST: string;
}